import { render, staticRenderFns } from "./VatItemEdit.vue?vue&type=template&id=d7a3e74e&"
import script from "./VatItemEdit.vue?vue&type=script&lang=ts&"
export * from "./VatItemEdit.vue?vue&type=script&lang=ts&"
import style0 from "./VatItemEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})
